import {PromiseWorker} from "./promiseWorker.js";
import {errorOutput} from "./errorOutput.js";
import {__t} from "../helpers/translate.js";
import {sendEventsList} from "./sendEventsList.js";


export default async function executePromises(state, params, props, inParallel = true) {
    const requestsPromises = new PromiseWorker($api, props.requests, EventBus, state);
    params.isErrorResult = false;
    try {
        const results = await requestsPromises.executeAsyncRequests(inParallel);
        params.results = results;
        const errorsList = requestsPromises.getErrorsResponses(results);
        if (errorsList.length > 0 && props.showError) {
            params.isErrorResult = true;
            errorOutput(__t(props.nameError), JSON.stringify(errorsList), params.actionName);
        }
        await props.commit(props.commitName, params);
    } catch (err) {
        params.isErrorResult = true;
        console.log(err);
        if (props.showError) {
            errorOutput(__t(props.nameError), err, params.actionName);
        }
        if (params.statesLoading && Array.isArray(params.statesLoading)) {
            params.statesLoading.forEach(stateLoading => {
                state[stateLoading] = false;
            })
        }
        if(params.eventsList && Array.isArray(params.eventsList)){
            sendEventsList(params.eventsList, {
                statusResponse: 'operation_fail',
                isErrorResult: true,
                linkObjects: params?.linkObjects ?? null,
            });
        }
    }
}
